import { useEffect, useState } from "react";

function useRetry(callback, maxRetries, delay = 500) {
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    if (retryCount > 0 && retryCount <= maxRetries) {
      const retryTimer = setTimeout(() => callback(), delay);
      return () => clearTimeout(retryTimer);
    }
  }, [retryCount]);

  return { retryCount, setRetryCount };
}

export default useRetry;
